import { newsLetterValidationSchema, validateField as validateFieldFuc } from '../utils/validation.utils';
import { getAriaLabelFromOuterHTML } from '../utils/skin.utils';
import i18n from '../utils/translations.utils';
import { articleClickedData, productClickedData, buyNowClickedData } from '../utils/feedback.utils';
import { Env } from '@stencil/core';
import { ProductDetailsType } from '../utils/types';
import { getAbsolutePath } from '@src/data';

const languageMapper = {
  en: 'English',
  es: 'Spanish',
};

enum BIN_API {
  MIKMAK = 'mikmak',
  PRICESPIDER = 'pricespider',
}
const spanish = 'es';
const t = i18n.getTranslation.bind(i18n);

let checkedValue;

let signUpError;

let analyticsService = null;

export const handleFirstInteractionNewsletter = async () => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers.analyticsService;

    const customEvent = { data: 'newsletter signup start', component: 'newsletter signup' };
    analyticsService.registerEvent('event57', customEvent);
  }
};

export const handleRecommendedProductsOnLoad = async data => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    let productsData = await handlers.getRecommendedProductsFromState();

    if (data?.secondBlock) {
      productsData.map((items, index) => {
        if (index === 2) {
          data['list'] = [];
          data['list'].push(items);
        }
      });
    } else if (data?.thirdBlock) {
      productsData.map((items, index) => {
        if (index === 3) {
          data['list'] = [];
          data['list'].push(items);
        }
      });
    } else {
      data['list'] = productsData;
    }

    //binInit for PS

    const config = await handlers.getConfig();
    const buyItNow: any = config.buyItNow;

    if (buyItNow.api === BIN_API.PRICESPIDER) {
      handlePSonLoad(data['list'], buyItNow.api);
      const bin = await handlers.binService.getBinApi(buyItNow.api);

      const args = {
        ps_key: Env.API_KEY_PRICE_SPIDER,
        ps_language: buyItNow[buyItNow.api].language,
        ps_country: buyItNow[buyItNow.api].country,
        ps_url: buyItNow[buyItNow.api].url,
        ps_trackUrl: buyItNow[buyItNow.api].trackUrl,
        ps_versionUrl: buyItNow[buyItNow.api].versionUrl,
      };

      await bin.binInit(...Object.values(args));
    }

    if (buyItNow.api === BIN_API.MIKMAK) {
      let mikMakElement, binInitElement;
      binInitElement = data['elements'].find(item => item.name === 'aiba-bin-init');
      if (binInitElement) {
        mikMakElement = binInitElement.data.product.data['elements'].find(item => item.name === 'aiba-mik-mak');
      }

      if (mikMakElement) {
        let appId = Env[buyItNow[buyItNow.api].appId];
        mikMakElement['data'] = {
          ...buyItNow[buyItNow.api],
          appId,
        };
      }
    }

    return data;
  }
};

const handlePSonLoad = (productList: ProductDetailsType[], binProvider: string) => {
  document.querySelector('.aiba-element-wrapper') && document.querySelector('.aiba-element-wrapper').remove();
  if (binProvider === BIN_API.PRICESPIDER) {
    const psWrapper = document.createElement('div');
    psWrapper.classList.add('aiba-element-wrapper', 'hidden');
    psWrapper.style.display = 'none';
    document.body.appendChild(psWrapper);
    productList?.forEach((productData: ProductDetailsType) => {
      console.log('productData', productData);
      const psButton = document.createElement('div');
      psButton.classList.add('ps-widget');
      psButton.setAttribute('ps-sku', productData.smartProductId);
      psButton.setAttribute('id', `product-${productData.smartProductId}`);
      document.querySelector('.aiba-element-wrapper').appendChild(psButton);
    });
  }
};

export const handleRecommendedArticlesOnLoad = async data => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const article_data = await handlers.getRecommendedArticlesFromState();
    data['articles'] = [];
    article_data?.map((item, index) => {
      if (index < 6) data['articles']?.push(item);
    });
    return data;
  }
};

//feedback handlers

async function formatFeedbackResponse() {
  let productFeedback = [];
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const recommendedProducts = await handlers.getRecommendedProductsFromState();
    if (recommendedProducts) {
      productFeedback = recommendedProducts.map(recommendedProduct => ({
        productId: recommendedProduct.smartProductId,
        productRoutine: recommendedProduct.routineName ? recommendedProduct.routineName : 'NA',
        productClicked: false,
        buyNowClicked: false,
        productInView: false,
      }));
    } else {
      console.info('null state.recommendedProducts');
    }
    let articleFeedback = [];
    const recommendedArticles = await handlers.getRecommendedArticlesFromState();
    if (recommendedArticles) {
      articleFeedback = recommendedArticles.map(recommendedArticle => ({
        articleId: recommendedArticle.id,
        articleClicked: false,
        articleInView: false,
      }));
    } else {
      console.info('null state.recommendedArticles');
    }

    return { articles: articleFeedback, products: productFeedback };
  }
}

async function getFeedbackData() {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const config = await handlers.getConfig();
    const { brand, locale, division } = config.brand;
    let data = await handlers.getQuizPayloadForML();
    let quizAnalysisResults = JSON.parse(JSON.stringify(data));
    quizAnalysisResults.map(item => {
      delete item.answers[0].surveyQuestionId;
    });
    const profile = await handlers.getUserProfile();
    return {
      meta: {
        brand,
        division,
        locale,
        username: profile.username ? profile.username : 'NA', //state.userProfile.username,
      },
      results: {
        quiz: quizAnalysisResults,
      },
      feedback: await formatFeedbackResponse(),
    };
  }
}

export const sendFeedback = async feedbackData => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    let feedbackService = handlers.feedbackService;
    const config = await handlers.getConfig();
    const apiDetails = config.apiConfig;
    const apiUrl = `${Env[apiDetails.baseUrl]}${Env[config.apiConfig.apiEndpoints.feedback]}`;
    const apikey = `${Env[apiDetails.apiKey]}`;
    (await feedbackService.getFeedbackInstance('feedbackML')).sendFeedback(feedbackData, apiUrl, apikey);
  }
};

export const handleLearnMoreClick = async (productDetail: any, event: Event) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const feedbackBaseData = await getFeedbackData();
    const productID = productDetail?.smartProductId;
    const feedbackData = productClickedData(productID, feedbackBaseData);
    sendFeedback(feedbackData);
    console.log(event, 'product-wrapper__product__link');
  }
};

export const handleBinInit = async (event: Event) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const config = await handlers.getConfig();
    const buyItNow: any = config?.buyItNow;
    const bin = await handlers.binService?.getBinApi(buyItNow.api);
    await bin?.binInit(buyItNow[buyItNow.api].url);
    console.log('@AIBA[handleBinInit]', event);
  }
};
const isPriceSpiderButtonVisible = dataValue => {
  return document.querySelector(`[ps-sku='${dataValue}']`)?.className?.split(' ')?.includes('ps-enabled');
};

const binWidget = async (event: Event, smartId, product) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const target = event.currentTarget;
    const handlers = window['AIBA']['utils'];
    const config = await handlers.getConfig();
    const buyItNow: any = config.buyItNow;
    const bin = await handlers.binService.getBinApi(buyItNow.api);
    target['dataset']['value'] = smartId;
    await bin.binClick(target, buyItNow[buyItNow.api].theme, buyItNow[buyItNow.api].locale);
    event['data'] = {
      identifierValue: product['identifierValue'] || '',
      productName: product['productName'] || '',
      brand: product['brandName'] || '',
      category: product['category'] || '',
      size: product['size'] || '',
    };
    const feedbackBaseData = await getFeedbackData();
    const feedbackData = buyNowClickedData(smartId, feedbackBaseData);
    sendFeedback(feedbackData);
    analyticsService?.registerEvent('event38', event);
  }
};
export const handleBinClick = async (event: Event, smartId, product) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const dataValue = smartId;
    const btnClick: any = event.currentTarget;
    const handlers = window['AIBA']['utils'];
    const config = await handlers.getConfig();
    const buyItNow: any = config.buyItNow;

    if (buyItNow['api'] === BIN_API.PRICESPIDER) {
      if (typeof (window as any).PriceSpider !== 'undefined' && typeof (window as any).PriceSpider.rebind !== 'undefined') {
        (window as any).PriceSpider.rebind();
      }

      if (isPriceSpiderButtonVisible(dataValue)) {
        await binWidget(event, smartId, product);
      } else {
        const waitForPriceSpider = setInterval(() => {
          if (isPriceSpiderButtonVisible(dataValue)) {
            if (typeof (window as any).PriceSpider !== 'undefined' && typeof (window as any).PriceSpider.rebind !== 'undefined') {
              (window as any).PriceSpider.rebind();
            }
            btnClick.click();
            clearInterval(waitForPriceSpider);
          }
        }, 100);
      }
    } else {
      await binWidget(event, smartId, product);
    }
  }
};

export const handleNavigationBlockButtonClick = async (event: any) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    console.log(event, '@AIBA[navigation block button clicked]');
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers?.analyticsService;
    await handlers.setStateRetakeJourney(true);
    let event1 = {};
    let analysisState = await handlers.getStateRetakeJourney();
    let analysisStateText = `skin analysis - ${analysisState ? 'retake' : 'take'} journey`;
    event1['data'] = { label: analysisStateText };
    event1['virtualAgent'] = analysisStateText;
    analyticsService?.registerEvent('event16', event1);

    handleNewsLetterCheckBox(false, event);
    await handlers.initState();
    await handlers.getNextJourney('selfie_intro_screen');
  }
};

export const handleArticleClicked = async (event: Event, articleDetail: any) => {
  console.log(event, '@AIBA[handleArticleClicked]');
  if (window['AIBA'] && window['AIBA']['utils']) {
    const articleID = articleDetail['id'];
    const articleTitle = articleDetail['title'];
    const articleURL = articleDetail['pageUrl'];
    const feedbackBaseData = await getFeedbackData();
    const feedbackData = articleClickedData(articleID, feedbackBaseData);
    sendFeedback(feedbackData);
    const handlers = window['AIBA']['utils'];
    let analyticsService = handlers.analyticsService;

    let customEvent = {};
    customEvent['data'] = { title: articleTitle, url: articleURL };

    analyticsService?.registerEvent('event63', customEvent);
  }
};

export async function availableGender() {
  return {
    [await t('app.gender.male')]: 'M',
    [await t('app.gender.female')]: 'F',
    [await t('app.gender.other')]: 'O',
    [await t('app.gender.unkown')]: 'U',
  };
}

export async function supportedGender() {
  return Object.values(await availableGender());
}
export const exporthandleValidationNewsLetter = async value => {
  try {
    const result = await validateField('name', value, newsLetterValidationSchema);
    if (result.message) {
      let event = new CustomEvent('event-options-error', { detail: result.details[0].message });
      document.dispatchEvent(event);
    }
    return result;
  } catch (error) {
    console.error(error);

    return error;
  }
};

const processDataForV3Results = async (quiz, questions, skin) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];

    //selectedOptions - [[], [], ...] (is an array of arrays)
    let selectedOptions = await handlers.getQuizOptionSelected();

    let selectedOptionsValues = Object.values(selectedOptions);

    let selectedOptionsFlat = selectedOptionsValues.flat(1);

    let newQuiz, newQuestions, newSkin;

    let quizGroupIDs = ['yourSkin', 'yourSkinGoals'];

    if (quiz) {
      newQuiz = quiz.flat(2);
      const temp = newQuiz.map(item => {
        if (quizGroupIDs.includes(item.groupId)) {
          let newAnswersArray = [];
          item.answers.map(obj => {
            newAnswersArray.push({ ...obj, answerText: obj.title });
          });
          item.answers = newAnswersArray;
          return { ...item, answers: item.answers.filter(i => selectedOptionsFlat.includes(i.answerId)) };
        } else {
          let newAnswersArray = [];
          item?.answers?.map(obj => {
            newAnswersArray.push({ ...obj, answerText: obj.title });
          });
          item.answers = newAnswersArray;
          return { ...item };
        }
      });

      newQuiz = JSON.parse(JSON.stringify(temp));
      newQuiz.map(item => {
        item.questionId = item?.answers[0]?.surveyQuestionId;
        delete item?.answers[0]?.surveyQuestionId;
      });
    }

    if (questions) {
      newQuestions = questions;
    }

    if (skin) {
      newSkin = skin;
    }

    return { newQuiz, newQuestions, newSkin };
  }
};
export const handleNewsLetterCheckBox = async (checked, event) => {
  console.log('@AIBA[handleNewsLetterCheckBox]', event);
  (event?.target as any).checked = checked;
  checkedValue = checked;
};

export const formErrorhandler = async err => {
  signUpError = err;
  console.log(signUpError);
};
export const handleNewsLetterSubmit = async (event, formdata) => {
  event.preventDefault();
  let api;
  let header;
  let locale;
  let brand;
  let profileStore;
  let language;
  let journeyType;
  const results: any = {
    quiz: [],
    questions: [],
  };
  // let gender = '';
  let name = '';
  let dob = '';

  const firstName = await validateField('firstName', formdata.firstName, newsLetterValidationSchema);
  const lastName = await validateField('lastName', formdata.lastName, newsLetterValidationSchema);
  const email = await validateField('email', formdata.email, newsLetterValidationSchema);
  const dobField = await validateField('dob', formdata.dob, newsLetterValidationSchema);

  if (firstName._object.firstName && lastName._object.lastName && email._object.email && dobField._object.dob) {
    if (window['AIBA'] && window['AIBA']['utils']) {
      const handlers = window['AIBA']['utils'];

      const resultQuizDataFromState = await handlers.getQuizAnalysisResultsFromState();
      const resultQuizData = JSON.parse(JSON.stringify(resultQuizDataFromState));
      const resultQuestionsData = await handlers.getQuizAnalysisResultsFromState();
      name = await handlers.getUserName();
      const config = await handlers.getConfig();
      api = config.profileStore.api;
      header = config.profileStore[api].header;
      locale = config.brand.locale;
      brand = config.brand.brand;
      profileStore = config.profileStore;
      language = config.brand?.locale?.split('-')[0];
      journeyType = config.brand.journey_type;

      profileStore[api]['apiKey'] = Env.API_KEY_FORMV3;
      const langQuizNode = {
        questionId: language === spanish ? 2000248813 : 2000151011,
        answers: [
          {
            answerId: language === spanish ? [2237] : [2236],
            answerText: languageMapper[language],
            title: languageMapper[language],
          },
        ],
      };

      let identifierValues = [];
      const recomm_products = await handlers.getRecommendedProductsFromState();
      recomm_products?.forEach(item => {
        identifierValues?.push(item.smartProductId);
      });
      const recommendationIdNode = {
        questionId: 5100001167,
        answers: [{ answerId: [244], answerText: identifierValues, title: identifierValues }],
      };

      const { newQuiz } = await processDataForV3Results(resultQuizData, resultQuestionsData, null);

      if (profileStore?.formV3?.header?.entity === 'epsilon' && journeyType === 'personalcare') {
        results.quiz = [...newQuiz, langQuizNode, recommendationIdNode];
      } else if (profileStore?.formV3?.header?.entity === 'epsilon') {
        results.quiz = [...newQuiz];
      }
      event.results = { ...results };
      const profileData = {
        contactDetail: {
          email: formdata.email,
        },
        consumerIdentity: {
          firstName: formdata.firstName ? formdata.firstName : name,
          lastName: formdata.lastName ? formdata.lastName : name,
          dateOfBirth: formdata.dob ? formdata.dob : dob,
        },
        consent: {
          legalAgeConsent: true,
        },
        results,
      };

      const consentChecked = await handlers.getConsentCheckedValue();

      if (consentChecked && checkedValue){
        profileData['additionalSubscription'] = [
          { serviceId: profileStore['additionalSubscription']['brandEmailConsentOptins'], optIn: true },
          { serviceId: profileStore['additionalSubscription']['unileverEmailConsentOptins'], optIn: true },
          { serviceId: profileStore['additionalSubscription']['healthConsentOptins'], optIn: true },
        ];
      } else if(consentChecked){
        profileData['additionalSubscription'] = [
          { serviceId: profileStore['additionalSubscription']['healthConsentOptins'], optIn: true },
        ];
      } else{
        if(checkedValue){
          profileData['additionalSubscription'] = [
            { serviceId: profileStore['additionalSubscription']['brandEmailConsentOptins'], optIn: true },
            { serviceId: profileStore['additionalSubscription']['unileverEmailConsentOptins'], optIn: true },
          ];
        }
      }
      

      formdata.formSubmission = true;
      const availableGenderArray = await availableGender();
      const supportedGenderArray = await supportedGender();
      const genderArray = {
        availableGenderArray,
        supportedGenderArray,
      };

      if (window['AIBA'] && window['AIBA']['utils']) {
        const handlers = window['AIBA']['utils'];
        analyticsService = handlers.analyticsService;

        const recommendedProducts = await handlers.getRecommendedProductsFromState();
        const pdfService = await handlers.pdfService;

        const config = await handlers.getConfig();

        let brandInfo = config['brandInfo'];

        try {
          // let arialabel = '';
          // arialabel = event?.currentTarget?.ariaLabel ? event?.currentTarget?.ariaLabel : getAriaLabelFromOuterHTML(event?.currentTarget?.outerHTML, 'button');
          // event.target['eventTitle'] = arialabel;
          event.target['eventTitle'] = 'Submit';

          await analyticsService?.registerEvent('event2', event);

          let [resultV3] = await Promise.all([
            handlers.profileService.saveProfile(profileData, api, header, locale, brand, profileStore, genderArray).catch(error => {
              throw error;
            }),
            config?.pdf?.enable === true && generatePdf(recommendedProducts, formdata.firstName, formdata.email, brandInfo, pdfService.generatePdfWithContent),
          ]);

          if (!resultV3) {
            resultV3 = {
              data: {
                status: '200',
                downstreamApiResponse: '',
              },
            };
            resultV3['status'] = 200;
          }

          if (resultV3 && resultV3.status === 202) {
            resultV3.data.downstreamApiResponse = resultV3.data.status;
            await analyticsService.registerEvent('event58', {
                data: 'Successful Sign Up',
                brandOptin: checkedValue,
                component: 'newsletter signup',
            });
            if (checkedValue) {
              const customEvent = {
                data: {
                  brandOptIn: ['brandEmailConsent optin', 'legalAgeConsent optin', 'unileverEmailConsent optin'],
                },
              };
              await analyticsService?.registerEvent('event50', customEvent);
            } else {
              await analyticsService?.registerEvent('event62', {
                data: { brandOptOut: ['brandEmailConsent', 'legalAgeConsent', 'unileverEmailConsent'] },
              });
            }
          }

          if (resultV3 && resultV3.status === 202) {
            console.log('@AIBA[pdf-submission]: succcessfull');
            const scrollDiv = () => {
              const successElement = document.querySelector('aiba-app').shadowRoot?.querySelector('.newsletter-container.successStatus') as HTMLElement;
              window.scrollTo({
                behavior: 'smooth',
                top: successElement.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 200,
              });
            };
            setTimeout(scrollDiv, 100);

            return true;
          }
        } catch (error) {
          if (error?.status === 400) {
            return {
              status: 400,
              message: 'Bad request',
            };
          }
        }
      }
    }
  }
};

export const generatePdf = async (recommendedProducts, name, email, brandinfo, generatePdfWithContent) => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    try {
      const config = await handlers.getConfig();
      const pdfTemplateURLs = config.pdfTemplateURLs;
      const URL = getAbsolutePath('');

      const templateurrls = key => {
        const urls = {
          footer: `${URL}${Env[pdfTemplateURLs.footer]}`,
          header: `${URL}${Env[pdfTemplateURLs.header]}`,
          mail: `${URL}${Env[pdfTemplateURLs.mail]}`,
          body: `${URL}${Env[pdfTemplateURLs.body]}`,
        };
        return urls[key];
      };
      const data = await generatePdfWithContent(
        {
          recommendedProductsOthers: recommendedProducts,
          name: name ? name.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) : t('newsletter-signup-pdf-mailer-defaultName'),
          emailId: email,
          brandname: brandinfo.brandname,
          bransiteurl: brandinfo.bransiteurl,
          bransite: brandinfo.bransite,
          brandphoneNumber: brandinfo.brandphoneNumber,
        },
        templateurrls,
        `${Env.AIBA_SERVICES_BASE_URL}${Env[config.apiConfig.apiEndpoints.pdfmailer]}`,
        Env.API_KEY_AIBA_SERVICES,
      );
      return data;
    } catch (error) {
      console.error('[newsletter-signup.pdfGenaration.error] ', error);
    }
  }
};
export const getNewsLetterSchema = () => {
  return newsLetterValidationSchema;
};

export const handleNewsLetterLinkClick = async (href, event: Event) => {
  console.log(href, '@AIBA[handleNewsLetterLinkClick]');
  const handlers = window['AIBA']['utils'];
  analyticsService = handlers.analyticsService;
  analyticsService?.registerEvent('event2', event);
};

export const handleProductRatingsOnLoad = async () => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const config = await handlers.getConfig();
    const ratings: any = config.ratings;
    const productRatingsApi: any = config?.ratings?.api;
    console.log('ratings ', productRatingsApi, ratings);
    const productRatingsApiData: any = productRatingsApi ? ratings[productRatingsApi] : '';
    const enabled = config.ratings?.enabled;

    return { productRatingsApi, productRatingsApiData, enabled };
  }
};
export const handleArticlesSliderNext = () => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers?.analyticsService;
    analyticsService.registerEvent('event2', { target: { eventTitle: 'Next Slide - Recommended Articles' } });
  }
};

export const handleArticlesSliderPrev = () => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers?.analyticsService;
    analyticsService.registerEvent('event2', { target: { eventTitle: 'Back Slide - Recommended Articles' } });
  }
};
export const handleRecommendedProductsDrawer = event => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers?.analyticsService;
    let customEvent = {};
    customEvent['target'] = {};
    customEvent['target']['eventTitle'] = `${event.target.text} - click`;
    // customEvent['target']['textContent'] = event.target.text;
    analyticsService.registerEvent('event2', customEvent);
  }
};

export const handleMikMaKBuyNowClick = async (product: any, event: any) => {
  event['data'] = {
    identifierValue: product['identifierValue'] || '',
    productName: product['productName'] || '',
    brand: product['brandName'] || '',
    category: product['category'] || '',
    size: product['size'] || '',
  };
  const feedbackBaseData = await getFeedbackData();
  const feedbackData = buyNowClickedData(product?.smartProductId, feedbackBaseData);
  sendFeedback(feedbackData);
  analyticsService?.registerEvent('event38', event);
};

export const handleCloseModal = async event => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers.analyticsService;
    await handlers.setFeedbackPopupData(false);
    const showPopup = await handlers.getFeedbackPopupData();
    const feedbackPopup = document?.querySelector('aiba-app')?.shadowRoot?.querySelector('aiba-generic-block#popup') as HTMLElement;
    if (!showPopup && feedbackPopup) feedbackPopup.style.display = 'none';
    analyticsService?.registerEvent('event2', event);
    event['data'] = [];
    event['data']['surveyID'] = `user feedback popup`;
    event['data']['surveyQuesAns'] = ``;
    analyticsService.registerEvent('event30', event);
  }
};
export const handlethumbsUpIconSelected = async event => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers?.analyticsService;
    const thumbsUpIcon = document?.querySelector('aiba-app')?.shadowRoot?.querySelector('#thumbUpBtn') as any;
    const thumbsDownIcon = document?.querySelector('aiba-app')?.shadowRoot?.querySelector('#thumbDownBtn') as any;
    if (thumbsDownIcon) {
      thumbsDownIcon?.classList?.remove('active');
    }
    if (thumbsUpIcon) thumbsUpIcon?.classList?.add('active');
    analyticsService?.registerEvent('event2', event);
  }
};
export const handletubmbsDownIconSelected = async event => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers?.analyticsService;
    const thumbsUpIcon = document?.querySelector('aiba-app')?.shadowRoot?.querySelector('#thumbUpBtn') as any;
    const thumbsDownIcon = document?.querySelector('aiba-app')?.shadowRoot?.querySelector('#thumbDownBtn') as any;
    if (thumbsUpIcon) {
      thumbsUpIcon?.classList?.remove('active');
    }
    if (thumbsDownIcon) thumbsDownIcon?.classList?.add('active');
    analyticsService?.registerEvent('event2', event);
  }
};

export const handleResultDidLoad = async () => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers?.analyticsService;
    const showPopup = await handlers.getFeedbackPopupData();
    const data = {};
    data['list'] = await handlers.getRecommendedProductsFromState();
    analyticsService = handlers.analyticsService;
    await analyticsService?.registerEvent('event1', { page: ' aiba result screen' });

    const customResultsEvent = {};
    customResultsEvent['data'] = [];
    customResultsEvent['label'] = 'AIBA - Beauty Advisor completed';
    customResultsEvent['component'] = 'Beauty Advisor';

    let quizInfo: string = '';
    let analysisState = await handlers.getStateRetakeJourney();
    let analysisStateText = `skin analysis - ${analysisState ? 'retake' : 'take'} quiz`;
    quizInfo = analysisStateText;
    customResultsEvent['data']['quizInfo'] = quizInfo;
    await analyticsService.registerEvent('event25', customResultsEvent);
    const customProductsEvent = {};
    customProductsEvent['data'] = data['list'];
    await analyticsService?.registerEvent('event11', customProductsEvent);

    const feedbackBaseData = await getFeedbackData();
    sendFeedback(feedbackBaseData);

    const checkbox = document?.querySelector('aiba-app')?.shadowRoot?.querySelector('.checkbox') as HTMLElement;

    checkbox.addEventListener('keydown', async function (event) {
      if (event.key === 'Enter') {
        checkedValue === undefined ? (checkedValue = false) : (checkedValue = checkedValue);
        handleNewsLetterCheckBox(!checkedValue, event);
      }
    });

    const trappedDiv = document?.querySelector('aiba-app')?.shadowRoot?.querySelector('aiba-generic-block#popup') as HTMLElement;
    document?.querySelector('aiba-app')?.shadowRoot?.querySelector('aiba-generic-block#popup ') as HTMLElement;

    let lastFocusedElement = null;
    trappedDiv.setAttribute('tabindex', '0');

    trappedDiv.addEventListener('keydown', function (event) {
      if (event.key === 'Tab') {
        const focusableElements = trappedDiv.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const firstElement = focusableElements[0] as HTMLElement;
        const lastElement = focusableElements[focusableElements.length - 1] as HTMLElement;

        if (event.shiftKey && lastFocusedElement === firstElement) {
          lastElement.focus();
          event.preventDefault();
        } else if (!event.shiftKey && lastFocusedElement === lastElement) {
          firstElement.focus();
          event.preventDefault();
        }
      }
    });

    trappedDiv.addEventListener('focusin', function (event) {
      lastFocusedElement = event.target;
    });

    let startTime;
    function focusElement(timestamp) {
      const svgWrapper = document?.querySelector('aiba-app')?.shadowRoot?.querySelectorAll('.bv_stars_svg_no_wrap svg') as any;
      svgWrapper?.forEach(function (svg) {
        svg.removeAttribute('style');
      });

      const input = document?.querySelector('aiba-app')?.shadowRoot?.querySelectorAll('.input') as any;
      input?.forEach(item => {
        const label = item.getAttribute('label');
        item.setAttribute('aria-label', label);
      });

      if (!startTime) {
        startTime = timestamp;
      }
      const elapsedTime = timestamp - startTime;
      if (elapsedTime < 10000) {
        requestAnimationFrame(focusElement);
      }
    }
    requestAnimationFrame(focusElement);

    if (showPopup) {
      setTimeout(() => {
        const feedback = document?.querySelector('aiba-app')?.shadowRoot?.querySelector('aiba-generic-block#popup') as HTMLElement;
        const headerHeight = document.querySelector('header').offsetHeight;
        const popup = feedback.querySelector('#popup') as HTMLElement;
        const topHeight = `calc(35% + ${headerHeight}px)`;
        if (feedback) {
          feedback.style.display = 'block';
          popup.style.setProperty('top', topHeight);
        }
        const closeCTA = feedback.querySelector('#closeModal .btn') as any;
        closeCTA.setAttribute('tabindex', '-1');
        feedback.querySelector('input').setAttribute('aria-label', 'comment');
        closeCTA.focus();
        const event = new Event('onLoadEvent');
        event['data'] = [];
        event['data']['label'] = 'user feedback popup';
        event['id'] = 'user feedback popup';
        analyticsService.registerEvent('event29', event as Event);
      }, 10000);
    }
  }
};

export const genericBlockWillLoadhandler = async data => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    analyticsService = handlers?.analyticsService;
    let productsData = await handlers.getRecommendedProductsFromState();
    let quizData = await handlers.getQuizPayload();
    let tipsData = await handlers.getTipsData();
    let tipsId = await handlers.getTipsIds();
    let tips_text;
    let id = data._id?.split('-')[0];
    tipsId?.data?.map(elem => {
      if (id === elem.section && elem.type == 'tips') {
        elem.recommendations.map(item => {
          if (quizData.find(i => i.answers[0].answerId === item.answerId[0])) {
            tipsData.map(_data => {
              if (item.tipId === _data.id) {
                tips_text = _data.content;
              }
            });
          }
        });
      }
    });
    if (data._id === 'wash-tips') {
      const dynamicData = {
        'aiba-label': { 'wash-tips': tips_text },
      };
      return dynamicData;
    } else if (data._id === 'polish-tips') {
      const dynamicData = {
        'aiba-label': { 'polish-tips': tips_text },
      };
      return dynamicData;
    }
    tipsId?.data?.map(elem => {
      let matchingData;
      if (id === elem.section && elem.type == 'heading') {
        if (elem.section === 'wash') {
          matchingData = [];
          matchingData[0] = quizData?.find(i => i.questionId === elem?.questionID[0]);
          matchingData[1] = quizData?.find(i => i.questionId === elem?.questionID[1]);
          elem.recommendations.map(item => {
            if (item.answerId[0] == matchingData[0].answers[0].answerId && item.answerId[1] == matchingData[1].answers[0].answerId) {
              tipsData.map(_data => {
                if (item.tipId === _data.id) {
                  tips_text = _data.content;
                }
              });
            }
          });
        } else {
          matchingData = quizData?.find(i => i.questionId === elem?.questionID[0]);
          elem.recommendations.map(item => {
            if (item.answerId == matchingData.answers[0].answerId) {
              tipsData.map(_data => {
                if (item.tipId === _data.id) {
                  tips_text = _data.content;
                }
              });
            }
          });
        }
      }
    });
    if (data._id === 'wash-heading') {
      const dynamicData = {
        'aiba-label': { 'wash-heading': tips_text },
      };
      return dynamicData;
    } else if (data._id === 'polish-heading') {
      const dynamicData = {
        'aiba-label': { 'polish-heading': tips_text },
      };
      return dynamicData;
    } else if (data._id === 'shower-care') {
      const dynamicData = {
        'aiba-label': { 'shower-care': tips_text },
      };
      return dynamicData;
    }

    productsData.map(elem => {
      if (elem.routineName === 'recommendation' && data?.dynamic) {
        elem.product_tips;
        tips_text = elem.product_tips;
      }
    });
    const dynamicData = {
      'aiba-label': { 'dynamic-tips': tips_text },
    };
    return dynamicData;
  }
};

export const validateField = validateFieldFuc;
